import React from "react";
import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { SLIDES, slideDesktopUrl, slideMobileUrl } from "../../data/slides";

const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const TopCarousel = () => (
  <Carousel fade={false} interval={prefersReducedMotion() ? null : 5000} pause="hover" aria-label="Featured tours">
    {SLIDES.map((item, idx) => (
      <Carousel.Item key={item.id}>
        <picture>
          <source media="(max-width: 575px)" srcSet={slideMobileUrl(item.id)} width="800" height="800" />
          <img
            className="d-block w-100"
            src={slideDesktopUrl(item.id)}
            alt={item.alt}
            width="1800"
            height="700"
            loading={idx === 0 ? "eager" : "lazy"}
            fetchpriority={idx === 0 ? "high" : "low"}
            decoding={idx === 0 ? "sync" : "async"}
          />
        </picture>
        <div className="carousel-overlay" />
        <Carousel.Caption className="carousel-caption-custom">
          <div className="carousel-caption-inner">
            <h2 className="carousel-slide-title">{item.header}</h2>
            <p className="carousel-slide-subtitle">{item.caption}</p>
            <div className="carousel-slide-buttons">
              {item.links.map((link) =>
                link.to ? (
                  <Link key={link.label} to={link.to} className="btn-brand carousel-slide-btn">
                    {link.label}
                  </Link>
                ) : (
                  <a key={link.label} href={link.href} className="btn-brand carousel-slide-btn">
                    {link.label}
                  </a>
                )
              )}
            </div>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    ))}
  </Carousel>
);

export default TopCarousel;
